import ReaderBadge from './ReaderBadge'
import withReaderBadge from './withReaderBadge'

const ConnectedReaderBadge = withReaderBadge(ReaderBadge)

export { ConnectedReaderBadge as ReaderBadge }
